// src/components/SelectCampaigns/components/ConfirmationSidebar.jsx
import React from 'react';
import PropTypes from 'prop-types';
import ConfirmCreateBudget from '../../reusable/Popups/ConfirmCreateBudget';
import Button from '../../reusable/Button/Button';
import css from '../SelectCampaigns.module.css';

const ConfirmationSidebar = ({
	tableRef,
	showError,
	errorText,
	onSubmit,
	buttonTitle,
}) => {
	return (
		<div className={css.selected}>
			<div className={css.selectedWrapper}>
				<div className={css.confirmTableWrapper} ref={tableRef}>
					<ConfirmCreateBudget />
				</div>
			</div>
			<div className={css.btn}>
				{showError && <p className={css.error}>{errorText}</p>}
				<Button
					styled="addClient"
					title={buttonTitle}
					onClick={onSubmit}
				/>
			</div>
		</div>
	);
};

ConfirmationSidebar.propTypes = {
	tableRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
	]),
	showError: PropTypes.bool,
	errorText: PropTypes.string,
	onSubmit: PropTypes.func.isRequired,
	buttonTitle: PropTypes.string.isRequired,
};

ConfirmationSidebar.defaultProps = {
	tableRef: null,
	showError: false,
	errorText: 'Please add some campaigns first',
};

export default ConfirmationSidebar;